import * as React from 'react';
import { Button, ButtonToolbar } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { IAgreement } from './Entities';

interface AgreementUserListRowProps {
    agreement: IAgreement;
    key: number;
    edit: (id: number) => void;
    delete: (id: number) => any;
    logs: (id: number) => void;
    openDeleteModal: (agreement: IAgreement) => void;
}

const AgreementListRow = (props: AgreementUserListRowProps) => {
    return (
        <tr>
            <td>{props.agreement.name}</td>
            <td className="tools">
                <ButtonToolbar className="pull-right btn-group-sm">
                    <Button bsStyle="danger" onClick={() => props.openDeleteModal(props.agreement)}>
                        <i className="material-icons">delete</i>{' '}
                        {Translate('agreements/list/row/button-label/delete')}
                    </Button>
                    <Button
                        onClick={() => {
                            props.edit(props.agreement.id);
                        }}
                        bsStyle="primary"
                    >
                        <i className="material-icons">edit</i>{' '}
                        {Translate('agreements/list/row/button-label/edit')}
                    </Button>
                    <Button onClick={() => props.logs(props.agreement.id)} bsStyle="default">
                        <i className="material-icons">list</i>{' '}
                        {Translate('agreements/list/row/button-label/logs')}
                    </Button>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default AgreementListRow;
